import { createPortal } from "react-dom";

import styled from "styled-components";

import { useTabularContext } from "./contexts/tabular-context.js";

const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.28);
    z-index: 2400;
`;

const Dialog = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(560px, calc(100vw - 32px));
    max-height: calc(100vh - 48px);
    overflow: auto;
    border-radius: 12px;
    border: 1px solid #d7e0ea;
    background: #fff;
    box-shadow: 0 20px 40px rgba(15, 23, 42, 0.18);
    z-index: 2401;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    border-bottom: 1px solid #e7edf4;
    font-size: 16px;
    font-weight: 700;
    color: #23384d;
`;

const Body = styled.div`
    padding: 18px;
    color: #42576b;
    font-size: 14px;
    line-height: 1.65;

    p {
        margin: 0 0 14px;
    }

    strong {
        color: #23384d;
    }
`;

const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0 18px 18px;
`;

const Button = styled.button`
    height: 36px;
    padding: 0 14px;
    border-radius: 8px;
    border: 1px solid #cfd9e5;
    background: #fff;
    color: #42576b;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
`;

export function TableGeneratorHelpModal() {
    const { helpShown, hideHelp } = useTabularContext();

    if (!helpShown) {
        return null;
    }

    return createPortal(
        <>
            <Backdrop onClick={hideHelp} />
            <Dialog className="table-generator-help-modal" role="dialog" aria-modal="true">
                <Header>
                    <span>도움말</span>
                    <Button type="button" onClick={hideHelp}>
                        닫기
                    </Button>
                </Header>
                <Body>
                    <p>이 도구는 visual 모드에서 LaTeX 표를 직접 삽입하고 편집할 수 있게 해줍니다.</p>
                    <p>
                        <strong>사용 방법.</strong> 셀, 행, 열을 선택하면 전체 LaTeX 코드를 직접 작성하지 않아도 테두리,
                        정렬, 병합 상태, 구조를 수정할 수 있습니다.
                    </p>
                    <p>
                        <strong>고급 편집.</strong> 더 복잡한 레이아웃이 필요하면 code 모드로 전환해서 내부 `tabular`
                        환경을 직접 편집할 수 있습니다.
                    </p>
                    <p>
                        <strong>캡션과 라벨.</strong> 캡션 관련 기능은 `tabular` 환경이 바깥 `table` 환경의 직접 자식일
                        때 동작합니다.
                    </p>
                </Body>
                <Footer>
                    <Button type="button" onClick={hideHelp}>
                        닫기
                    </Button>
                </Footer>
            </Dialog>
        </>,
        document.body,
    );
}
